export const MAXIMUM_PAGES = 7;
export let SIZES = /*#__PURE__*/function (SIZES) {
  SIZES["SMALL"] = "small";
  SIZES["NORMAL"] = "normal";
  return SIZES;
}({});